var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('h1',{staticClass:"title"},[_vm._v("Crea prodotto")]),_c('product-form',{attrs:{"submit-action":_vm.create,"fields":_vm.fields,"redirect-route":"products.show"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }